/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import { useEffect, useMemo, useState } from 'react';
import { getDaysInMonth } from '../../utils';

export const TODAY = 'Сегодня';
export const DATE = 'Дата';

function getWeeksInMonth(date) {
    const year = new Date(date).getFullYear();
    const month = new Date(date).getMonth();
    const weeks = [];
    const firstDate = new Date(year, month, 1);
    const lastDate = new Date(year, month + 1, 0);
    const numDays = lastDate.getDate();

    let dayOfWeekCounter = firstDate.getDay() === 0 ? 6 : firstDate.getDay() - 1;

    // eslint-disable-next-line no-plusplus
    for (let date1 = 1; date1 <= numDays; date1++) {
        if (dayOfWeekCounter === 0 || weeks.length === 0) {
            weeks.push([]);
        }
        weeks[weeks.length - 1].push(date1);
        dayOfWeekCounter = (dayOfWeekCounter + 1) % 7;
    }

    return weeks
        .filter(w => !!w.length)
        .map(w => ({
            start: w[0],
            end: w[w.length - 1],
            dates: w,
        }));
}

export const useArrayOfDays = (_value) => {
    const [ daysArr, setDaysArr ] = useState();
    const [ value, setValue ] = useState(_value);
    const [ today, setToday ] = useState(new Date(new Date(_value || null).setDate(1)));

    useEffect(() => {
        setToday(new Date(new Date(value || null).setDate(1)));
    }, [value]);

    useEffect(() => {
        const firstDayIndexOfWeekDay = today.getDay() === 0 ? 6 : today.getDay() - 1; // because our calendar start from Mon
        let counter = 1;

        const countOfDaysInMonth = getDaysInMonth(today);
        const days = Array.from({ length: 42 }, (v, i) => (i >= firstDayIndexOfWeekDay && counter <= countOfDaysInMonth ? counter++ : 0)); // generate arr of items for calendar
        if (days[35] === 0) {
            days.splice(35, 7);
        }
        setDaysArr(days);
    }, [today]);

    return [ daysArr, today, setValue ];
};

export const useDays = (_value) => {
    const [ daysArr, setDaysArr ] = useState();
    const [ value, setValue ] = useState(_value);
    const [ firstDayInChosenMonth, setFirstDayInChosenMonth ] = useState(new Date(new Date(_value || null).setDate(1)));

    const weeksInMonth = useMemo(() => (firstDayInChosenMonth ? getWeeksInMonth(firstDayInChosenMonth) : 0), [
        firstDayInChosenMonth,
    ]);
    const daysArrLength = useMemo(() => weeksInMonth.length * 7, [weeksInMonth]);

    const firstDateForCalendar = useMemo(() => {
        const weekIndexOfFirstDateInMonth = firstDayInChosenMonth.getDay() === 0 ? 6 : firstDayInChosenMonth.getDay() - 1; // from 0 (Monday) to 6 (Saturday);
        return new Date(
            new Date(firstDayInChosenMonth).getFullYear(),
            new Date(firstDayInChosenMonth).getMonth(),
            (weekIndexOfFirstDateInMonth - 1) * -1,
        );
    }, [firstDayInChosenMonth]);

    useEffect(() => {
        setFirstDayInChosenMonth(new Date(new Date(value || null).setDate(1)));
    }, [value]);

    useEffect(() => {
        const days = Array.from({ length: daysArrLength }, (v, i) => {
            const nextDate = new Date(firstDateForCalendar);
            return new Date(nextDate.setDate(nextDate.getDate() + i));
        });
        setDaysArr(days);
    }, [firstDayInChosenMonth]);

    return [ daysArr, firstDayInChosenMonth, setValue ];
};
